import React, { useState } from "react";
import { useApplication } from "@/contexts/ApplicationContext";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useStartAssessment } from "@/hooks/useAssessments";
import { useOrientationQuizCloudFunctions } from "@/hooks/useOrientationQuizCloudFunctions";

const quizQuestions = [
  {
    id: 1,
    text: "When entering the warehouse, what safety measures are in place?",
    options: [
      { id: "1A", text: "Safety gloves", points: 0 },
      { id: "1B", text: "Hi-vis and Safety glasses", points: 0 },
      { id: "1C", text: "Hard hat", points: 0 },
      { id: "1D", text: "Hi-vis and Safety shoes", points: 1 },
    ],
  },
  {
    id: 2,
    text: "What app is used to reach out to the Driver-ops team?",
    options: [
      { id: "2A", text: "Track-POD", points: 0 },
      { id: "2B", text: "WhatsApp", points: 0 },
      { id: "2C", text: "HIVED Team app", points: 1 },
      { id: "2D", text: "Telegram", points: 0 },
    ],
  },
  {
    id: 3,
    text: "In which scenario can you leave a parcel unattended (e.g. in front of the door)?",
    options: [
      { id: "3A", text: "If no-one is at home", points: 0 },
      {
        id: "3B",
        text: "If the customer verifies it on Track-POD OR sends written confirmation after you engage with them",
        points: 1,
      },
      {
        id: "3C",
        text: "If you are busy and want to finish the route quicker",
        points: 0,
      },
      { id: "3D", text: "If the neighbour is not at home", points: 0 },
    ],
  },
  {
    id: 4,
    text: "You complete a route and you have 3 undelivered parcels, and even after re-attempting, were unable to complete the delivery. What should you do next?",
    options: [
      {
        id: "4A",
        text: "Wait outside the customers home until they return",
        points: 0,
      },
      { id: "4B", text: "Leave the parcels in a safe place", points: 0 },
      {
        id: "4C",
        text: "Return the parcels to the warehouse or a nearby PUDO point",
        points: 1,
      },
      {
        id: "4D",
        text: "Go home and re-attempt them first thing the next morning",
        points: 0,
      },
    ],
  },
  {
    id: 5,
    text: "In which scenario can you leave a parcel unattended, even if the customer hasn't verified it?",
    options: [
      {
        id: "5A",
        text: "You are tired and want to go home quicker",
        points: 0,
      },
      { id: "5B", text: "Food/Perishable parcels", points: 1 },
      { id: "5C", text: "Any parcel when you think its safe", points: 0 },
      { id: "5D", text: "When the neighbour says its safe", points: 0 },
    ],
  },
  {
    id: 6,
    text: "How many 'Proof of Delivery' pictures are required when delivering to a flat in an apartment.",
    options: [
      { id: "6A", text: "1", points: 0 },
      { id: "6B", text: "2", points: 0 },
      { id: "6C", text: "3", points: 0 },
      { id: "6D", text: "4+", points: 1 },
    ],
  },
  {
    id: 7,
    text: "When would you message the DriverOps Team (Live Chat) on the HIVED team app?",
    options: [
      {
        id: "7A",
        text: "When you have on road issues and emergency vehicle issues",
        points: 1,
      },
      { id: "7B", text: "When you have vehicle issues", points: 0 },
      { id: "7C", text: "when your invoice is missing a payment", points: 0 },
      { id: "7D", text: "When you want to have a chat", points: 0 },
    ],
  },
  {
    id: 8,
    text: "When should you return your undelivered parcels?",
    options: [
      { id: "8A", text: "The next day", points: 0 },
      { id: "8B", text: "Mid way through your route", points: 0 },
      { id: "8C", text: "By the end of the day", points: 1 },
      {
        id: "8D",
        text: "End of the week with all undelivered parcels at once",
        points: 0,
      },
    ],
  },
  {
    id: 9,
    text: "What should you do once all returned parcels are scanned but on the HIVED team app it still says 1 in Parcels section?",
    options: [
      { id: "9A", text: "Leave and continue on with your day", points: 0 },
      {
        id: "9B",
        text: "Tell security or PUDO Point staff member to rescan parcels",
        points: 1,
      },
      { id: "9C", text: "Let the DriverOps team know", points: 0 },
      {
        id: "9D",
        text: "Take a picture of the parcel that wasn't marked as scanned",
        points: 0,
      },
    ],
  },
  {
    id: 10,
    text: "Which one of the following are you NOT allowed to go through with vans?",
    options: [
      { id: "10A", text: "Blackwall Tunnel", points: 0 },
      { id: "10B", text: "Silvertown Tunnel", points: 0 },
      { id: "10C", text: "Rotherhithe Tunnel", points: 1 },
      { id: "10D", text: "Dartford Crossing", points: 0 },
    ],
  },
  {
    id: 11,
    text: "You are nearing the end of your route, and there has been an accident on the road resulting in standstill traffic. You have been idle for 10 minutes. What do you do?",
    options: [
      {
        id: "11A",
        text: "Wait and see if the traffic clears out soon, as you have already delivered the majority of your parcels",
        points: 0,
      },
      {
        id: "11B",
        text: "Wait for a few minutes (10+) to see if traffic moves, then inform Live Support if traffic remains at a standstill",
        points: 1,
      },
      {
        id: "11C",
        text: "Wait 30 minutes. If not progress then end route and bring the parcel back to the depot to reattempt tomorrow",
        points: 0,
      },
      {
        id: "11D",
        text: "Inform dispatch immediately and keep them updated",
        points: 0,
      },
    ],
  },
  {
    id: 12,
    text: "You arrive at your next stop, but when you get to the door, the person says that the customer does not live there. You call the customer and it turns out they put their old address in. You are at the correct address that is on our system, but they actually live at a different address that is 7 minutes away from the one you went to. What do you do?",
    options: [
      {
        id: "12A",
        text: "Inform the Driver-Ops team of the situation and follow their instructions. They will advise how to ensure customer is happy in this instance",
        points: 1,
      },
      {
        id: "12B",
        text: "Advise customer to update address via the Hived Customer support for next day delivery. Bring the parcel back and it will get delivered to the new address tomorrow",
        points: 0,
      },
      {
        id: "12C",
        text: "Advise the customer to change their address through live chat Hived customer support and inform them that you might be returning today, if possible",
        points: 0,
      },
      {
        id: "12D",
        text: "Adjust route if possible then update the customer on delivery time, inform your Hived Support team of the delay and why it's happening",
        points: 0,
      },
    ],
  },
  {
    id: 13,
    text: "You get to stop 10 but you can't find the parcel. You then realise that you have delivered stop 10's parcel to the stop before at stop 9 and you still have stops 9's parcel in the van. How do you deal with this?",
    options: [
      {
        id: "13A",
        text: "Return at the end of the route to correct the mistake to avoid further delays",
        points: 0,
      },
      {
        id: "13B",
        text: "Return back to Stop 9 to correct the mistake, then deliver to stop 10",
        points: 0,
      },
      {
        id: "13C",
        text: "Inform only stop 10 customer of the delay then correct the mistake by returning to stop 9 to swap around the parcels",
        points: 0,
      },
      {
        id: "13D",
        text: "Inform HIVED Support of the delay due to the error, then inform both the customers and correct the mistake with an apology. Then move on with the remaining parcels",
        points: 1,
      },
    ],
  },
  {
    id: 14,
    text: "You are delivering in a block of flats, the customer let you inside the building but now they are not answering their door. What do you do?",
    options: [
      {
        id: "14A",
        text: "Leave the parcel with a neighbour or safe place/concierge if available",
        points: 1,
      },
      {
        id: "14B",
        text: "Leave the parcel at the door, take photos and notes",
        points: 0,
      },
      {
        id: "14C",
        text: "Call, knock and wait until they answer. You know they're in so might as well deliver directly to the customer",
        points: 0,
      },
      {
        id: "14D",
        text: "Mark as undelivered and return the parcel to be reattempted the next day",
        points: 0,
      },
    ],
  },
  {
    id: 15,
    text: "You are delivering an age-restricted item but the customer looks as if they could be under 25 years old. What should you do?",
    options: [
      {
        id: "15A",
        text: "Still deliver if they say someone above the age is home",
        points: 0,
      },
      { id: "15B", text: "Ask for ID and write DOB in notes", points: 1 },
      { id: "15C", text: "Mark the parcel as undelivered", points: 0 },
      {
        id: "15D",
        text: "Leave with neighbour that looks above the age of 25",
        points: 0,
      },
    ],
  },
];

const OrientationQuiz: React.FC = () => {
  const [started, setStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const { application } = useApplication();
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const { toast } = useToast();
  const navigate = useNavigate();

  // Assessment mutations
  const { mutate: startAssessment } = useStartAssessment();
  const { submitOrientationQuiz } = useOrientationQuizCloudFunctions();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleStartQuiz = () => {
    setStarted(true);

    // Record the assessment start time if we have an application ID
    if (application?.id) {
      startAssessment({
        applicationId: application.id,
        type: "orientation-quiz",
      });
    }
  };

  const handleAnswerChange = (questionId: number, optionId: string) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: optionId,
    }));
  };

  const handleNext = () => {
    if (currentQuestion < quizQuestions.length) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Format answers for submission
      const formattedAnswers: Record<string, string> = {};
      Object.entries(answers).forEach(([questionId, answerId]) => {
        formattedAnswers[questionId] = answerId;
      });

      // Submit to cloud function - score calculation is now done on the backend
      const result = await submitOrientationQuiz.mutateAsync({
        applicationId: application.applicationId,
        resultBreakdown: {
          answers: formattedAnswers,
        },
      });

      if (!result.success) {
        toast({
          title: "Submission Error",
          description: result.message || "Failed to submit quiz",
          variant: "destructive",
        });
        return;
      }

      // Handle success
      if (result.data?.passed) {
        toast({
          title: "Quiz Passed",
          description: "You have successfully passed the orientation quiz!",
        });

        // Navigate to the next stage if provided
        if (result.data.nextStage) {
          navigate(`/${result.data.nextStage}`);
        } else {
          // Default navigation if no next stage is provided
          navigate("/personal-details");
        }
      } else {
        toast({
          title: "Quiz Failed",
          description:
            "Unfortunately, you did not pass the orientation quiz. Please try again.",
          variant: "destructive",
        });

        // Navigate to failure page if provided, otherwise stay on quiz
        if (result.data?.nextStage) {
          navigate(`/${result.data.nextStage}`);
        }
      }
    } catch (error) {
      console.error("Error submitting quiz:", error);
      toast({
        title: "Submission Error",
        description:
          "There was an error submitting your quiz. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  console.log("OrientationQuiz", started);
  if (!started) {
    return (
      <Card className="p-6 shadow-sm">
        <h2 className="text-xl font-semibold mb-4">Orientation Quiz</h2>
        <div className="prose max-w-none mb-6">
          <p className="text-gray-700 mb-4">
            This quiz will test your understanding of the key safety procedures,
            delivery protocols, and operational guidelines covered in your
            orientation session.
          </p>
          <p className="text-gray-700 mb-4">
            Please answer all questions to the best of your ability. Your
            answers will be evaluated based on the job requirements to determine
            if you pass.
          </p>
        </div>
        <Button
          onClick={handleStartQuiz}
          className="w-full md:w-auto bg-honeycomb hover:bg-amber-500 text-white"
        >
          Start Quiz
        </Button>
      </Card>
    );
  }

  const activeQuestion = quizQuestions.find((q) => q.id === currentQuestion);
  if (!activeQuestion) return null;

  const progress = (currentQuestion / quizQuestions.length) * 100;

  return (
    <Card className="p-5 shadow-sm">
      <div className="mb-4">
        <div className="h-2 w-full bg-gray-200 rounded-full">
          <div
            className="h-2 bg-honeycomb rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className="text-right text-sm text-gray-500 mt-1">
          Question {currentQuestion} of {quizQuestions.length}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div key={activeQuestion.id} className="space-y-4">
          <div className="mb-4">
            <h3 className="text-lg font-medium">{activeQuestion.text}</h3>
          </div>

          <RadioGroup
            value={answers[activeQuestion.id] || ""}
            onValueChange={(value) =>
              handleAnswerChange(activeQuestion.id, value)
            }
            className="space-y-3"
          >
            {activeQuestion.options.map((option) => (
              <div
                key={option.id}
                className="flex items-center space-x-3 p-3 border border-gray-200 rounded-md"
              >
                <RadioGroupItem value={option.id} id={option.id} />
                <Label
                  htmlFor={option.id}
                  className="flex-1 font-normal text-gray-700"
                >
                  {option.text}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <div className="flex justify-between pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={handlePrevious}
            disabled={currentQuestion === 1}
          >
            Previous
          </Button>

          {currentQuestion < quizQuestions.length ? (
            <Button
              type="button"
              onClick={handleNext}
              className="bg-honeycomb hover:bg-amber-500 text-white"
              disabled={!answers[currentQuestion]}
            >
              Next
            </Button>
          ) : (
            <Button
              type="submit"
              className="bg-honeycomb hover:bg-amber-500 text-white"
              disabled={
                !quizQuestions.every((q) => answers[q.id]) || isSubmitting
              }
            >
              {isSubmitting ? (
                <>
                  <span className="animate-spin mr-2 h-4 w-4 border-2 border-white border-t-transparent rounded-full inline-block"></span>
                  Submitting...
                </>
              ) : (
                "Submit Quiz"
              )}
            </Button>
          )}
        </div>
      </form>
    </Card>
  );
};

export default OrientationQuiz;
